import { useContext } from 'react';
import { UserContext } from 'routes/login/userContext';
import { reduce } from 'ramda';

const useUserPermissionMap = () => {
  const userContext = useContext(UserContext);
  const permissions = userContext.role?.permissions || [];
  const userPermissionMap = reduce(
    (pMap: any, p) => {
      pMap[p] = true;
      return pMap;
    },
    {},
    permissions
  );

  return userPermissionMap;
};

export default useUserPermissionMap;
